import { COLOR } from "utils/constant";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { CustomError, InfoPros } from "interface/index";
import React, { FC, useEffect, useState } from "react";
import CustomButton from "./Button";
import { useInfoStore } from "store/error";
import styles from "styles.module.css";
import { t } from "i18next";

const ErrorInfo: FC<{ show: boolean; text: string }> = ({ text, show }) => {
	//Todo: add styls
	return (
		<div style={{ color: COLOR.StatusRed, display: show ? "block" : "none" }}>
			<span>{text}</span>
		</div>
	);
};

export default ErrorInfo;

interface InfoData extends InfoPros {
	error?: CustomError;
}
const ErrorModal = () => {
	const [infoData, setInfoData] = useState<InfoData>(Object);

	const { info, resetStore, showCustomError } = useInfoStore();
	useEffect(() => {
		const handleKeyPress = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				handleClose();
			}
		};

		document.addEventListener("keydown", handleKeyPress);
		// setInfoData(props);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
		};
	}, []);

	useEffect(() => {
		if (info === null || info === undefined) {
			handleClose();
			return;
		}
		if (info.infoType === null) return;

		if (info.infoType === "Error") {
			setInfoData({
				...info,
				title: showCustomError ? info?.title : t("ErrorTitle"),
				description: showCustomError
					? info?.description
					: t("ErrorDescription"),
				show: true,
				actions: [],
			});
		} else {
			setInfoData({
				title: info?.title,
				description: info?.description,
				show: true,
				actions: info?.actions || [],
				infoType: info?.infoType || "Info",
			});
		}
	}, [info]);

	const handleClose = () => {
		setInfoData({ ...Object(), show: false });
		handleReset();
	};
	const handleReset = () => {
		resetStore();
	};
	return (
		<div>
			{infoData?.show && (
				<Dialog
					title={infoData?.title}
					onClose={handleClose}
					style={{
						minWidth: "400px",
						color: "red",
						// color:
						// 	infoData?.infoType === "Success"
						// 		? COLOR.StatusGreen
						// 		: COLOR.StatusRed,
					}}
					className={infoData?.infoType === "Error" ? "info-error " : ""}
				>
					<p
						style={{
							margin: "25px",
							textAlign: "center",
							color:
								infoData?.infoType === "Success"
									? COLOR.StatusGreen
									: infoData?.infoType === "Warning"
										? COLOR.Orange
										: "",
						}}
					>
						{infoData.description}
					</p>
					<DialogActionsBar>
						{infoData.actions?.map((action, index) => (
							<div key={index}>
								<CustomButton
									label={action.text}
									onClick={action.btn}
									disabled={action.disabled || false}
									bgColor={action.bgColor}
									color={action.textColor}
									btnStyle={{
										width: "100%",
										justifyContent: "center",
									}}
								/>
							</div>
						))}
					</DialogActionsBar>
				</Dialog>
			)}
		</div>
	);
};
export { ErrorModal };
